"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var React = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _AaTextInputComponent = _interopRequireDefault(require("../airasia-textInput-component/AaTextInputComponent"));

var _AaIcon = _interopRequireDefault(require("../airasia-icon-component/AaIcon.component"));

var _AaDropdown = _interopRequireDefault(require("../airasia-dropdown-component/AaDropdown.component"));

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var _AaAutoComplete = require("./AaAutoComplete.model");

var _uiUtils = require("@airasia/ui-utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AaAutoCompleteMobileView = function AaAutoCompleteMobileView(props) {
  var _React$useState = React.useState(true),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      autoFocus = _React$useState2[0],
      isAutoFocus = _React$useState2[1];

  var _React$useState3 = React.useState(props.controls.textInputControls.controls.value),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      oldValue = _React$useState4[0],
      setOldValue = _React$useState4[1];

  var eleRef = React.useRef();

  var _React$useState5 = React.useState(function () {
    if (props.controls.textInputControls.controls.attrName == 'origin' && props.controls.dropDownControls.controls.isMobileLayout && _reactNativeWeb.Platform.OS === 'web') {
      return props.controls.textInputControls.controls.value;
    }

    return '';
  }),
      _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
      value = _React$useState6[0],
      onChangeText = _React$useState6[1];

  var onOptionPress = function onOptionPress(key, index) {
    props.selectAndCloseMobileView(key.StationName + ' (' + key.StationCode + ')', key, index);
  };

  var onInputFocus = function onInputFocus(bool) {
    props.controls.textInputControls.controls.onInputFocus(bool);
  };

  var updateMasterState = function updateMasterState(attrName, value) {
    onChangeText(value);
    props.controls.textInputControls.controls.updateMasterState('', value);
  };

  var closePlaceSelectionModal = function closePlaceSelectionModal() {
    props.controls.closeMobileView(oldValue, false);
  };

  React.useEffect(function () {
    isAutoFocus(true);
  }, []);

  var autoCompleteMobileView = function autoCompleteMobileView() {
    return /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
      style: styles.container
    }, /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
      style: styles.autoCompleteHeader
    }, /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
      style: styles.headerTitle
    }, /*#__PURE__*/React.createElement(_reactNativeWeb.Text, {
      style: styles.headerText
    }, props.controls.textInputControls.translation.title)), /*#__PURE__*/React.createElement(_reactNativeWeb.TouchableWithoutFeedback, {
      onPress: closePlaceSelectionModal
    }, /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
      style: styles.headerCloseIcon
    }, /*#__PURE__*/React.createElement(_AaIcon["default"], {
      controls: {
        iconName: "CLOSE_ICON",
        iconStyle: {
          height: 24,
          width: 24
        }
      }
    })))), /*#__PURE__*/React.createElement(_reactNativeWeb.View, null, /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
      style: styles.autoComplete
    }, /*#__PURE__*/React.createElement(_AaTextInputComponent["default"], {
      controls: {
        value: value,
        updateMasterState: updateMasterState,
        onInputFocus: onInputFocus,
        isFloatingLabelRequired: false,
        textInputStyles: props.controls.textInputControls.controls.textInputStyles,
        otherTextInputProps: {
          autoFocus: autoFocus,
          ref: eleRef
        },
        selectTextOnFocus: props.controls.textInputControls.controls.selectTextOnFocus,
        fullscreenView: props.controls.fullscreenView
      },
      translation: {
        placeholder: props.controls.textInputControls.translation.placeholder
      }
    })), /*#__PURE__*/React.createElement(_AaDropdown["default"], {
      controls: _objectSpread(_objectSpread({}, props.controls.dropDownControls.controls), {}, {
        isMobileLayout: props.controls.dropDownControls.controls.isMobileLayout,
        onOptionPress: onOptionPress,
        fullscreenView: props.controls.fullscreenView
      }),
      data: props.controls.dropDownControls.data
    })));
  };

  return _reactNativeWeb.Platform.OS === 'ios' ? /*#__PURE__*/React.createElement(_reactNativeWeb.SafeAreaView, {
    style: {
      flex: 1,
      backgroundColor: "transparent"
    }
  }, autoCompleteMobileView()) : autoCompleteMobileView();
};

var styles = _StyleSheet["default"].create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    height: '100%',
    width: '100%',
    web: {
      backgroundColor: 'white',
      width: '100%',
      position: 'fixed'
    },
    backgroundColor: 'white',
    borderBottomWidth: 0
  },
  autoCompleteHeader: {
    flexDirection: 'row',
    width: '100%',
    height: 56,
    backgroundColor: '#fff',
    borderColor: "#fff",
    web: {
      shadowOffset: {
        width: 0,
        height: 2
      },
      shadowOpacity: 0.25,
      shadowRadius: 3.84
    },
    android: {
      elevation: 9,
      borderBottomWidth: 1,
      borderColor: '#d9dbe0'
    },
    ios: {
      borderBottomWidth: 1,
      borderColor: '#d9dbe0'
    }
  },
  headerTitle: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    web: {
      zIndex: '100'
    }
  },
  headerCloseIcon: {
    position: 'absolute',
    right: 21,
    top: 15,
    zIndex: 9999,
    android: {
      elevation: 9
    }
  },
  headerText: {
    fontSize: 16,
    color: '#1d1d1d',
    fontFamily: _uiUtils.DefaultTokens.FONT_MEDIUM,
    web: {
      fontWeight: '500',
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB
    }
  },
  autoComplete: {
    padding: 10,
    paddingHorizontal: 16,
    web: {
      width: '100%',
      zIndex: '99',
      paddingVertical: 15
    },
    ios: {
      backgroundColor: '#FFF'
    }
  },
  resultSection: {
    width: '100%',
    position: 'absolute',
    web: {
      height: 600
    }
  }
});

var _default = AaAutoCompleteMobileView;
exports["default"] = _default;